document.addEventListener("ShoptetDOMPageContentLoaded", function () {
  customProduct();
});
document.addEventListener("ShoptetPageSortingChanged", function () {
  customProduct();
});
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function () {
  customProduct();
});
$(document).ready(function () {
  customProduct();
});

shoptet.scripts.setCustomCallback('shoptet.products.splitSingleWidgetParameter', function() {
    $(".product").each(function () {
    const $product = $(this);
    if($(this).find('.widget-parameter-wrapper').length === 1){
      $product.find(".p-in").append($product.find(".widget-parameter-wrapper").clone());
    }
  });
});



function customProduct() {
  var dny = {
    "Pondělí": "Po",
    "Úterý": "Út",
    "Středa": "St",
    "Čtvrtek": "Čt",
    "Pátek": "Pá"
  };
  $(".product").each(function () {
    const $product = $(this);
  /*  if($(this).find('.widget-parameter-wrapper').length === 1){
      $product.find(".p-in").append($product.find(".widget-parameter-wrapper").clone());
    }*/

    $product.find(".flags .flag").each(function () {
      const $flag = $(this);
      const dayText = $flag.text().trim();
      $flag.removeClass("active");

      if (dny[dayText]) {
        $flag.text(dny[dayText]);
      }


    });



    $product.find('a.image').append($product.find('.flags').clone().addClass('otherFlags'));
    $product.find(".flags:not(.otherFlags)").addClass("daysToBake");
    const $priceStandard = $product.find(".price-standard");
    if ($priceStandard.length) {
      $product.find(".prices").prepend($priceStandard);
    }
  });
}
